<template>
<PuSkeletonTheme :duration="0.1" :color="skeletonColor" :highlight="skeletonHighlight">
      <vx-card>
        <div class="my-2">
          <h5 class="mb-2">
            <PuSkeleton class="block shadow-md " style="width: 50%; height: 25px;">
            </PuSkeleton>
          </h5>
        </div>
        <div class="my-4">
          <div class="flex justify-between">
            <PuSkeleton class="block shadow-md w-full" style="width: 100%; height: 17px;">
            </PuSkeleton>
          </div>
          <PuSkeleton class="block mt-2 shadow-md w-full" style="width: 100%; height: 7px;">
          </PuSkeleton>
        </div>
        <div class="flex justify-between flex-wrap">
          <!---<vs-button class="mt-4 font-semibold" type="gradient" color="#E45353" gradient-color-secondary="#B42B45">
            View Progress
          </vs-button>--->
          <PuSkeleton class="mt-4 mr-2 shadow-lg font-semibold w-full" style="width: 100%; height: 35px;">
          </PuSkeleton>
        </div>
      </vx-card>
  </PuSkeletonTheme>
</template>

<script>
export default {
  computed: {
    cardColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return '#FFFFFF'
      if (theme === 'midnight') return '#050035'
      if (theme === 'dark') return '#161719'
    },
    skeletonColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(224, 224, 224)'
      if (theme === 'midnight') return 'rgb(6,0,73)'
      if (theme === 'dark') return 'rgb(27, 30, 34)'
    },
    skeletonHighlight () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(248, 248, 248)'
      if (theme === 'midnight') return 'rgb(27 25 53)'
      if (theme === 'dark') return 'rgb(94 94 94 / 73%)'
    }
  }
}
</script>

